angular.module('aprima-provider-api').factory('LockRepository', ['AprimaRestangular', 'ServerInfoRepository', 'CurrentUser', '$q', '_',
    function (AprimaRestangular, ServerInfoRepository, CurrentUser, $q, _) {
        'use strict';

        var unsupportedLockTypePromise = $q.reject(new Error('Lock Type is not supported by older server'));

        function getRestangularizedLock(lockObjId) {
            return AprimaRestangular.get().one('locks', lockObjId);
        }

        function getQueryStringObj(instanceId) {
            var qs = {};

            if (instanceId) {
                qs.instanceId = instanceId;
            }

            return qs;
        }

        function isNewLockingSupported() {
            return ServerInfoRepository.isFeatureSupported('LockManagement');
        }

        function isLockTypeSupported(lockType) {
            return isNewLockingSupported() || _.startsWith(lockType.toLowerCase(), 'message');
        }

        function lock(lockType, lockObjId, instanceId) {
            if (isNewLockingSupported()) {
                return getRestangularizedLock(lockObjId)
                    .customPUT({}, lockType, getQueryStringObj(instanceId));
            }
            else {
                if (!isLockTypeSupported(lockType)) {
                    return unsupportedLockTypePromise;
                }

                return AprimaRestangular.get().all('message/' + lockObjId).customPUT({
                    ObjectId: lockObjId,
                    LockType: lockType,
                    InstanceId: instanceId || CurrentUser.deviceId
                }, 'lock')
                    .then(function (m) {
                        m.LockType = m.LockType || 'Message';
                        return m;
                    });
            }
        }

        function unlock(lockType, lockObjId, instanceId) {
            if (isNewLockingSupported()) {
                return getRestangularizedLock(lockObjId)
                    .customDELETE(lockType, getQueryStringObj(instanceId));
            }
            else {
                if (!isLockTypeSupported(lockType)) {
                    return unsupportedLockTypePromise;
                }

                return AprimaRestangular.get().all('message/' + lockObjId).customDELETE('lock');
            }
        }

        function isLocked(lockType, lockObjId, instanceId) {
            if (isNewLockingSupported()) {
                return getRestangularizedLock(lockObjId)
                    .one(lockType)
                    .get(getQueryStringObj(instanceId));
            }
            else {
                if (!isLockTypeSupported(lockType)) {
                    return unsupportedLockTypePromise;
                }

                //this isLocked fn was defined in an older version of the client, but the endpoint that it calls
                //was not implemented by the server. isLocked() was added, but it was never called so it
                //did not cause problems. Now if it gets called when using an older server, just short circuit to
                //the error case instead of attempting to make a call to the server.
                return $q.reject(new Error('Cannot determine whether a resource is locked using an older server.'));
            }
        }

        return {
            lock: lock,
            unlock: unlock,
            isLocked: isLocked
        };
    }]);
